const getDocumentTracingObj = ({ documentTracing, type }, { correlationID }) => ({
  ...documentTracing,
  correlationID,
  type,
});

export default getDocumentTracingObj;
